"use strict";

exports.__esModule = true;
var _CreateUserScreen = require("./CreateUserScreen");
Object.keys(_CreateUserScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateUserScreen[key]) return;
  exports[key] = _CreateUserScreen[key];
});